module.exports = __webpack_public_path__ + "img/archiveDodIcon.fb969dec.svg";